import React, { useEffect, useState, useContext } from "react";
import AuthContext from "../../context/Auth/AuthContext";
import AuthService from "../../services/AuthService";
import calcStyles from "../../pages/calculation/calculation.module.css";
import styles from "./mini_dashboard.module.css";

const LABELS_RELATORIO = {
  lotes_total: "Total Pedidos",
  em_processamento: "Em processamento",
  concluidos: "Concluídos",
};

// posicionamento no grid (lotes à esquerda em 2 linhas; direita empilhada)
const AREA_CLASS = {
  lotes_total: styles.areaLotes,
  em_processamento: styles.areaProc,
  concluidos: styles.areaConcl,
};

const MiniDashboardRelatorio = () => {
  const { user } = useContext(AuthContext);
  const idUser = user?.user?.id || null;

  const [data, setData] = useState({});
  const [loading, setLoad] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;

    (async () => {
      if (!idUser) {
        setError("Usuário não autenticado.");
        setLoad(false);
        return;
      }
      try {
        setLoad(true);
        setError("");

        const resp = await AuthService.getResumoDashHome(idUser);
        const json = resp?.data ?? resp;
        if (mounted) setData(json || {});
      } catch (e) {
        console.error("[ResumoDashHome] Falha no GET (Relatório)", {
          idUser,
          error: e?.message,
          status: e?.response?.status,
          statusText: e?.response?.statusText,
          data: e?.response?.data,
        });

        const msg =
          e?.response?.data?.message ||
          (e?.response?.status
            ? `${e.response.status} ${e.response.statusText || ""}`.trim()
            : e?.message) ||
          "Erro desconhecido";

        if (mounted) setError(`Falha ao carregar o resumo de relatório: ${msg}`);
      } finally {
        if (mounted) setLoad(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [idUser]);

  const fmtInt = (v) =>
    Number.isFinite(Number(v)) ? Number(v).toLocaleString("pt-BR") : "0";

  const entries = Object.entries(LABELS_RELATORIO);

  return (
    <div className={styles.wrap}>
      <div className={`${styles.miniGrid} ${styles.relatorioGrid}`}>
        {entries.map(([key, label]) => {
          const legendClass =
            key === "concluidos"
              ? styles.legendGreen
              : key === "em_processamento"
              ? styles.legendYellow
              : "";

          const valueClass =
            key === "concluidos"
              ? styles.valueGreen
              : key === "em_processamento"
              ? styles.valueYellow
              : "";

          return (
            <fieldset
              key={key}
              className={`${calcStyles.fieldset} ${styles.card} ${AREA_CLASS[key] || ""}`}
            >
              <legend className={legendClass}>{label}</legend>
              <div className={`${styles.value} ${valueClass}`}>
                {loading ? "—" : fmtInt(data?.[key])}
              </div>
            </fieldset>
          );
        })}
      </div>
      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
};

export default MiniDashboardRelatorio;
